import React, { createContext, useContext, useState, useCallback } from 'react';

const LayoutContext = createContext(null);
const STORAGE_KEY = 'sidebar-collapsed';

function readInitialCollapsed() {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export function LayoutProvider({ children }) {
  const [collapsed, setCollapsed] = useState(readInitialCollapsed);
  const [mobileOpen, setMobileOpen] = useState(false);

  const toggleCollapsed = useCallback(() => {
    setCollapsed((c) => {
      const next = !c;
      try { localStorage.setItem(STORAGE_KEY, String(next)); } catch (e) {}
      return next;
    });
  }, []);

  const value = { collapsed, toggleCollapsed, mobileOpen, setMobileOpen };
  return <LayoutContext.Provider value={value}>{children}</LayoutContext.Provider>;
}

export function useLayout() {
  const ctx = useContext(LayoutContext);
  if (!ctx) throw new Error('useLayout must be used within LayoutProvider');
  return ctx;
}
